import {formValidation} from '../form/form.js';

let formEl = $('.auth-register');
let waits = {};

formEl.on('submit', function(e){
	e.preventDefault();
	let thisEl = $(this);

	// wait
	if(waits[thisEl.attr('action')]) return false;
	waits[thisEl.attr('action')] = true;
	thisEl.addClass('wait');

	// prevent form submit
	e.preventDefault();

	// form data
	var formData = new FormData(this);

	// set action
	formData.set('action', thisEl.attr('action'));

	// set captcha
	var captchaEl = thisEl.find('textarea[name=g-recaptcha-response]');
	if(captchaEl.length > 0) formData.set('recaptcha', captchaEl.val());

	// send request to server
	$.ajax({
		url: ajaxurl,
		type: thisEl.attr('method') ? thisEl.attr('method') : 'post',
		dataType: 'json',
		processData: false,
		contentType: false,
		cache: false,
		data: formData,
		success: function(response){
			// stop wait
			waits[thisEl.attr('action')] = false;
			thisEl.removeClass('wait');

			// if no response
			if(!response) {
				alertify.error('Непредвиденная ошибка');
				return;
			}

			// validate form
			formValidation(response.errors, response.messages, thisEl);

			if(response.result == 'success') {
				let formEl = document.querySelector('.auth-register');
				let confirmEl = document.querySelector('.auth-register__confirm');
				formEl.style.display = 'none';
				confirmEl.style.display = 'flex';
			}
		},
		error: function(error){
			console.log(error);
			alertify.error('Непредвиденная ошибка')
		}
	});

	// prevent form submit
	return false;
});